/** "When to book flights: 95 fares show prices jump inside three weeks": metadata (the article is in ../bodies/when-to-book-flights-fare-data.js). */
export default {
  slug: 'when-to-book-flights-fare-data',
  category: 'Research',
  label: 'Research · November 2026',
  title: 'When to book flights: 95 fares show prices jump inside three weeks',
  seoTitle: 'When to Book Flights: How Far Ahead (2026 Data)',
  description: 'We tracked 95 round-trip fares. Prices were lowest about 3 to 6 weeks before takeoff, then rose to 14% above the two-month price by two weeks out.',
  dek: 'We pulled the daily price history behind 95 round trips on 16 routes to see what fares really do before departure. Booking very early earned nothing extra. Waiting past three weeks cost a lot.',
  author: 'Stephanie Ludwig',
  published: '2026-11-03',
  updated: '2026-11-03',
  faqs: [
    {
      q: 'How far in advance should you book a flight?',
      a: 'In our data, about three to six weeks before departure. The median fare on 47 November trips was 6.9% to 9.8% below its two-month price from 42 to 21 days out, and the typical cheapest day fell 38 days out.',
    },
    {
      q: 'Do flight prices go up closer to departure?',
      a: 'Yes, sharply inside three weeks. The median fare was back to its two-month level at 19 days, 14.1% above it at 14 days and 28.8% above it at 12 days, and 46 of 47 trips cost more two weeks out than at their cheapest point.',
    },
    {
      q: 'Is it cheaper to book flights months in advance?',
      a: 'Not on the trips we tracked. On 48 late-January trips, the median fare fell 9.2% between about five months and about two and a half months before departure, so booking four to five months ahead earned nothing extra.',
    },
    {
      q: 'Why do flight prices jump two weeks before departure?',
      a: 'Our data shows when prices rose, not why. A likely reason is the advance-purchase deadlines many fares carry: as each deadline passes, cheaper fares drop out of the results.',
    },
    {
      q: 'Is the best time to book different for international or holiday flights?',
      a: 'It can be. Our routes were mostly domestic and off-peak, and Google’s October 2026 analysis puts the lowest international prices at about 89 days before departure and the lowest Christmas fares at about 56 days.',
    },
    {
      q: 'Can I lock in a fare while I pay for it over time?',
      a: 'With Defera, your agreed-upon trip price is secured once your booking is approved, as long as you stay in good standing on your plan. Trips must depart at least 22 days after booking.',
    },
  ],
  related: [
    'cheapest-day-to-fly',
    'lock-flight-price-with-deposit',
    'basic-economy-real-cost',
  ],
};
